import { render, staticRenderFns } from "./SellerPaymentHistoryList.vue?vue&type=template&id=1b0f1d7c"
import script from "./SellerPaymentHistoryList.vue?vue&type=script&lang=js"
export * from "./SellerPaymentHistoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports